import { ComponentsVariants, isVariantOf } from '@/components.variants';
import resolveLink from '../resolveLink';
import resolveRTC from '../resolveRTC';

export const isToggleMenu = isVariantOf(ComponentsVariants.TOGGLE_MENU, true);

const defaultConfig = {
  groups: [],
  confirmationMessage: '',
  link: {},
  marketoProps: {
    formId: '',
    baseUrl: '',
    munchkinId: '',
    emailFieldname: '',
    emailCRMFieldname: '',
  },
};

export default (rawVal: any, page: any, pageModels: any) => {
  const {
    marketoFormID: formId,
    toggleGroup: groups = [],
    confirmationMessage,
    buttonCompound,
  } = rawVal || {};
  const {
    base_url: baseUrl,
    munchkin_id: munchkinId,
    email_fieldname: emailFieldname,
    email_crm_fieldname: emailCRMFieldname,
  } = pageModels?.config?.marketo || {};

  const parseGroupOption = (option: any) => ({
    label: option?.preferenceLabel || '',
    description: resolveRTC({ rawVal: option?.preferenceDescription || '' }),
    marketoName: option?.marketoName || '',
    crmName: option?.crmName || '',
    isMultiple: option?.isMultiple || false,
    value: option?.value || '',
  });

  const parseGroups = (groupList: any[]) =>
    groupList.map((group) => ({
      title: group?.groupTitle || '',
      description: group?.groupDescription || '',
      selectorType: [(group?.selectorType || '').toUpperCase()],
      options: (group?.toggleMenu || []).map(parseGroupOption),
    }));

  return {
    variant: ComponentsVariants.TOGGLE_MENU,
    ...defaultConfig,
    marketoProps: {
      ...defaultConfig.marketoProps,
      formId,
      baseUrl,
      munchkinId,
      emailFieldname,
      emailCRMFieldname,
    },
    groups: parseGroups(groups),
    confirmationMessage: resolveRTC({ rawVal: confirmationMessage || '' }),
    link: resolveLink({ rawVal: buttonCompound, page, pageModels }),
  };
};
